export class LanguageItem{
  public key:string;
  public value:string;

  constructor(obj = null){
    obj = obj || {}
    this.key = obj.key;
    this.value = obj.value;
  }
}